import axiosCall from 'src/services/axiosHelper';

export async function getUserPreference(preference: string, defaultValue: boolean): Promise<boolean> {
  const data = await axiosCall<string | boolean>({
    method: 'get',
    url: `/profile-settings/preferences/${preference}/default/${defaultValue}`,
  }, defaultValue);
  if (typeof data === 'string') {
    return data.toLowerCase() === 'true';
  }
  return data;
}

export async function setUserPreference(preference: string, value: string): Promise<void> {
  await axiosCall({
    method: 'put',
    url: `/profile-settings/preferences/${preference}/value/${value}`,
  });
}